import React from "react";
import { offerItems, pricing } from "../data/landing";
export function OfferBox() {
  return <div className="box" data-id="element-103" data-mp="1ymuy5jw0mjf6">
      <div className="blist" data-id="element-104" data-mp="1yn4ml31ewiir">
        <h3 className="btit" data-id="element-105" data-mp="1yk8pti1avzvw">✦ O que você vai receber:</h3>
        <div className="it" data-id="element-106" data-mp="1knls3d1ix5ox">
          <span className="iname" data-id="element-107" data-mp="1kodfw1ovpz4n">Coleção Equilíbrio 60+ · 5 tomos com 600 fichas</span>
          <span className="iprice" data-id="element-108" data-mp="1oonrbtvfxhqw">{pricing.originalPrice}</span>
        </div>
        {offerItems.map(item => <div className="it" key={item.name} data-id="element-109" data-mp="2cft7ka5amc1q">
            <span className="iname" data-id="element-110" data-mp="2hd2u9i1as9lv">{item.name}</span>
            <span className="ifree" data-id="element-111" data-mp="2hexk9arferwt">GRÁTIS</span>
          </div>)}
        <div className="tot" data-id="element-112" data-mp="23kwqkvfbzv3b">
          <span data-id="element-113" data-mp="23jllmsa5gham">Valor total:</span>
          <span className="totp" data-id="element-114" data-mp="27m880do1xa0f">{pricing.originalPrice}</span>
        </div>
      </div>
      <div className="prow" data-id="element-115" data-mp="2vcucjuyukc5o">
        <span className="cur" data-id="element-116" data-mp="2vbsrqys14bar">{pricing.price}</span>
        <div className="save" data-id="element-117" data-mp="303arxkm8a7uo">Economize {pricing.savings}</div>
      </div>
      <p className="urg" data-id="element-118" data-mp="304lzlvisnzr2">
        <i data-id="element-119" data-mp="35gdze4s3ybo5">✦</i>
        <span data-id="element-120" data-mp="35fup9a8p8rko">Pagamento único, sem mensalidade · Acesso imediato e vitalício</span>
      </p>
    </div>;
}